import { isEqual, isPlainObject } from "lodash";

export default function objectDifference(object = {}, base = {}) {
  return Object.entries(object).reduce((acc, cur) => {
    const [key, value] = cur;
    const baseValue = base[key];
    const isFunction = typeof value === "function" && typeof baseValue === "function";

    if (!isEqual(value, baseValue) && !isFunction) {
      const isObject = isPlainObject(value) && isPlainObject(baseValue);
      acc[key] = isObject ? objectDifference(value, baseValue) : value;
    }

    return acc;
  }, {});
}
